import { enums } from "common/enums";
import { Body } from "common/types";
import { extract, toAsyncResult } from "vsto/utils";
import { useVstoInterop } from "vsto/VstoInterop";

export function coercionTypeToString(value: string | any | undefined) {
  // в ручную ремапим значения, в рантайме т.к. CoercionType м/б как строкой, так и числом
  switch (value) {
    case enums.CoercionType.Html:
      return "html";
    case enums.CoercionType.Text:
      return "text";
    default: // прочие типы не поддерживаются Outlook-ом
      return value;
  }
}

export function useMailboxItemBody(): {
  getAsync: Body["getAsync"];
  setAsync: Body["setAsync"];
  setSelectedDataAsync: Body["setSelectedDataAsync"];
} {
  function setSelectedDataAsync(data: string, options, callback?) {
    const [opt, cb] = extract(options, callback);
    toAsyncResult(useVstoInterop().setCurrentItemBodySelectedData(data, coercionTypeToString(opt?.coercionType))).then(cb);
  }

  function getAsync(coercionType: string, options, callback?) {
    const [, cb] = extract(options, callback);
    toAsyncResult(useVstoInterop().getCurrentItemBody(coercionTypeToString(coercionType))).then(cb);
  }

  function setAsync(data: string, options?, callback?) {
    const [opt, cb] = extract(options, callback);
    toAsyncResult(useVstoInterop().setCurrentItemBody(data, coercionTypeToString(opt?.coercionType))).then(cb);
  }

  return {
    setSelectedDataAsync,
    getAsync,
    setAsync,
  };
}
